const { parseCurrency } = require('./numbers')

const parseStore = ({ delayFeePerMinute, hasCommissions, ...store }) => ({
  ...store,
  hasCommissions: Boolean(hasCommissions),
  delayFeePerMinute: parseCurrency(delayFeePerMinute)
})

export { parseStore }
